import Moment from 'moment-timezone'
import MomentDurationFormatSetup from 'moment-duration-format'

MomentDurationFormatSetup(Moment)

const timezone = Moment.tz.guess()

const getTimezones = () => {
  return {
    london: process.env.VUE_APP_TIMEZONE,
    local: timezone,
    isSame: timezone === process.env.VUE_APP_TIMEZONE
  }
}

const formatTo = ({ formatTo = 'fixture', date = Moment() }) => {
  const format = formatTo === 'fixture' ? 'MM/DD/YYYY HH:mm' : formatTo

  return Moment(date).format(format)
}

// helper function for checking month difference
const isMonthGT0 = ({ monthDiff }) => monthDiff > 0
const handleDayDifference = ({ monthDiff, dayDiff }) => {
  return isMonthGT0({ monthDiff }) ? monthDiff : dayDiff
}

const formatTimestamp = ({ formatTo = 'fixture', timestamp = Moment() }) => {
  const format = formatTo === 'fixture' ? 'MM/DD/YYYY HH:mm' : formatTo

  const originalTimezone = getTimezones().isSame
    ? Moment.unix(timestamp)
    : Moment.unix(timestamp).tz(getTimezones().london)
  const localTimezone = Moment.unix(timestamp).tz(getTimezones().local)

  const original = originalTimezone.format(format)
  const local = localTimezone.format('HH:mm')

  /*
    Note: Get month difference first, so we can handle day difference
    between month transition.
  */
  const monthDiff =
    parseInt(localTimezone.format('MM')) -
    parseInt(originalTimezone.format('MM'))

  const dayDiff =
    parseInt(localTimezone.format('DD')) -
    parseInt(originalTimezone.format('DD'))
  const numSign = dayDiff || isMonthGT0({ monthDiff }) > 0 ? '+' : '-'

  return {
    original,
    local,
    dayDiff: handleDayDifference({ monthDiff, dayDiff }),
    numSign,
    isSame: getTimezones().isSame
  }
}

const testDate = () => {
  return Moment()
    .add(16, 'days')
    .add(1, 'hours')
    .add(30, 'minutes')
    .utc()
}

const getDateNow = () => {
  return Moment().utc()
}

const getDateNowUnix = () => {
  return Moment().unix()
}

const compareTimestamp = (options = { comparer: 'isSameOrAfter' }) => {
  const timestampA = parseInt(options.timestampA)
  const timestampB = parseInt(options.timestampB)
  const comparer = options.comparer || 'isSameOrAfter'

  if (options.timestampA != undefined) {
    if (options.timestampB != undefined) {
      if (!isNaN(timestampA) && !isNaN(timestampB)) {
        switch (comparer) {
          case 'isSameOrAfter':
            return Moment(timestampA).isSameOrAfter(timestampB)
          case 'isSameOrBefore':
            return Moment(timestampA).isSameOrBefore(timestampB)
          case 'isSame':
            return Moment(timestampA).isSame(timestampB)
          case 'isAfter':
            return Moment(timestampA).isAfter(timestampB)
          case 'isBefore':
            return Moment(timestampA).isBefore(timestampB)
        }
      } else {
        throw new Error('Timestamp received is not a number')
      }
    } else {
      throw new Error('Timestamp B is undefined')
    }
  } else {
    throw new Error('Timestamp A is undefined')
  }
}

const epochFormat = ({ unit = 'seconds', format = null, epochTime }) => {
  const formatted = format
    ? Moment.duration(epochTime, unit).format(format)
    : Moment.duration(epochTime, unit).format()

  return formatted
}

export {
  formatTo,
  formatTimestamp,
  testDate,
  getDateNow,
  getTimezones,
  getDateNowUnix,
  compareTimestamp,
  epochFormat
}
